<template>
  <vx-card class="px-4">
    <!-- MAIL HEAD -->
    <div class="vx-row">
      <div class="vx-col w-full border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid flex justify-between flex items-center">
        <!-- Sender Details -->
        <div class="flex items-center">
          <div>
            <vs-avatar class="sender__avatar--single flex-shrink-0 mr-3 border-2 border-solid border-white" src="../../../img/avatar.png" size="65px"/>
          </div>

          <div class="flex flex-col">
            <h5 class="mb-1">{{ mailContent.sender.emailAddress.name }}</h5>
            <div class="flex items-center">
              <span class="text-sm">{{ mailContent.sender.emailAddress.address }}</span>
              <vs-dropdown vs-custom-content vs-trigger-click class="inline-flex cursor-pointer">
                <feather-icon icon="ChevronDownIcon" class="w-3 h-3"/>
                <vs-dropdown-menu style="z-index: 40001">
                  <div class="p-2">
                    <p class="text-sm mb-1">From: <span class="font-semibold"> {{ mailContent.sender.emailAddress.address }} </span></p>
                    <p class="text-sm mb-1">To: <span class="font-semibold"> {{ mailContent.toRecipients | csv }} </span></p>
                    <p class="text-sm mb-1">Date: <span class="font-semibold"> {{ mailContent.sentDateTime | time }} {{ mailContent.sentDateTime | formatDateTime }} </span></p>
                    <p class="text-sm mb-1" v-if="mailContent.ccRecipients.length">cc: <span class="font-semibold"> {{ mailContent.ccRecipients | csv }} </span></p>
                  </div>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </div>
        </div>
        <!-- /Sender Details -->

        <!-- Mail Time & Date -->
        <div class="flex flex-col justify-end">
          <span class="text-right">{{ mailContent.sentDateTime | time }}</span>
          <div class="flex justify-end mt-2">
            <span class="text-right">{{ mailContent.sentDateTime | formatDateTime }}</span>
          </div>
        </div>
      </div>
      <!-- /Mail Time & Date -->
    </div>

    <!-- MAIL CONTENT -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mail__content break-words mt-8 mb-4" v-html="mailContent.body.content"></div>
      </div>
    </div>

    <!-- MAIL ATTACHMENTS -->
    <div class="vx-row" v-if="mailContent.hasAttachments">
      <div class="vx-col w-full border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid mb-6 flex">
        <feather-icon icon="PaperclipIcon" class="mr-2"/>
        <span class="block py-4">ATTACHMENTS</span>
      </div>
      <div class="flex">
        <div class="mail__attachment" v-for="(attachment, index) in attachments" :key="index">
          <vs-chip color="primary" class="px-4 py-2 mr-3 cursor-pointer">
            <a :href="downloadFile(attachment)" style="color:rgba(255, 255, 255, 0.9);" :download="attachment.name" target="_blank">{{ attachment.name }}</a>
          </vs-chip>
        </div>
      </div>
    </div>
  </vx-card>
</template>

<script>
import FeatherIcon from "./components/FeatherIcon";
import VxCard from "./components/VxCard";

export default {
  props: {
    mailContent: {type: Object, required: true}
  },
  components: {
    FeatherIcon,
    VxCard
  },
  data() {
    return {
      attachments: []
    }
  },
  methods: {
    downloadFile(attachment) {
      return "data:" + attachment.contentType + ";base64," + attachment.contentBytes;
    }
  },
  mounted() {
    if (this.mailContent.hasAttachments) {
      let that = this;
      axios.get(this.crmApiPath + 'msgraph/emails/' + this.mailContent.id + '/attachments').then(response => {
        if (response.data.is_redirect) {
          window.location.href = response.data.redirect_url;
        }
        else {
          that.attachments = response.data.attachments.value;
        }
      }).catch(error => console.log(error));
    }
  },
}
</script>
